import React from "react";
import UserContext from "./UserContext.js";

const UserContextProvider = ({children}) => {
    const [user, setUser] = React.useState({
        appName:"Election Easy",
        banner:""
    })
    return(
        <UserContext.Provider value={{user, setUser}}>
        {children}
        </UserContext.Provider>
    )
}

export default UserContextProvider